import React from 'react'
import { cx } from 'emotion'
import styled from 'react-emotion'
import { connect } from 'react-redux'
import Link from 'redux-first-router-link'
import { themeGet as th } from 'styled-system'

import {
  selectIsFacebookTicket,
  selectIsTwitterTicket,
} from 'selectors/tickets'
import { selectIsForwarding, selectIsReplyHeaderExpanded } from 'selectors/page'
import {
  selectOpenExpandedAction,
  selectOpenForwardPageExpandedAction,
  selectOpenNotePageAction,
  selectOpenTicketPageAction,
} from 'selectors/pageActions'
import { Flex, Icon } from 'shared/ui'

import { CannedReplyDropdown } from 'ducks/cannedReplies'
import NavLink from './NavLink'

const NavBar = ({
  actionExpanded,
  className,
  commenting,
  forwarding,
  isExpanded,
  isFacebookTicket,
  isTwitterTicket,
  openForward,
  openNote,
  openReply,
  replying,
  ticketId,
}) => {
  return (
    <Flex className={cx(className, { commenting })}>
      <Flex className={className}>
        <NavLink
          className="addReply"
          to={openReply}
          active={replying && !forwarding}
        >
          Reply
        </NavLink>
        <NavLink className="addForward" to={openForward} active={forwarding}>
          Forward
        </NavLink>
        <NavLink
          active={commenting}
          className="addComment"
          color="golden"
          to={openNote}
        >
          Note
        </NavLink>
      </Flex>
      {replying && (
        <Flex className={className} flex="1 0 auto" justifyContent="flex-end">
          <CannedReplyDropdown ticketId={ticketId} />
          {!isFacebookTicket &&
            !isTwitterTicket && (
              <Link className={className} to={actionExpanded}>
                <Icon
                  name="more-horizontal"
                  ml={2}
                  color={isExpanded ? 'groovy' : undefined}
                />
              </Link>
            )}
        </Flex>
      )}
    </Flex>
  )
}

const select = state => {
  return {
    actionExpanded: selectOpenExpandedAction(state),
    forwarding: selectIsForwarding(state),
    isExpanded: selectIsReplyHeaderExpanded(state),
    isFacebookTicket: selectIsFacebookTicket(state),
    isTwitterTicket: selectIsTwitterTicket(state),
    openForward: selectOpenForwardPageExpandedAction(state),
    openNote: selectOpenNotePageAction(state),
    openReply: selectOpenTicketPageAction(state),
  }
}

export default connect(select)(styled(NavBar)`
  min-height: 24px;
  &.commenting {
    background-color: ${th('colors.note')};
  }

  ${NavLink} + ${NavLink} {
    margin-left: 20px;
  }
`)
